const view = {

	init() {

		// Open modal wanner gebruiker op switch klikt
		document.querySelectorAll('[data-target-modal]').forEach(function(element) {
			element.addEventListener('click', function(event) {
				let target = event.target.getAttribute('data-target-modal');
				let element = document.getElementById(target);
				let bootstrapModal = new bootstrap.Modal(element);
				bootstrapModal.show();
				return false;
			});
		});

	}

};

export default view;
